import { getAuthTokenClient } from '@/utils/helpers';
import {
  API_URLS,
  getJSONData,
  parseErrorMessage,
  TypeResponseError,
  TypeResponseSuccess,
} from '@/lib/api/config';

export type SubscriberStatusesResponse = {
  user_uuid: string;
  aged_out: boolean;
  active: boolean;
  active_count: number;
  summary_status: string;
  jwts: string | null;
};

export type GetSubscriberStatusesParams = {
  userUuid: string;
  authToken?: string;
};

export async function getSubscriberStatuses(
  params: GetSubscriberStatusesParams,
) {
  const { userUuid, authToken } = params;
  const config = {
    method: 'GET',
    headers: {
      Authorization: authToken ? authToken : await getAuthTokenClient(),
    },
  };

  const uri = `${API_URLS.SUBSCRIPTION_MANAGER}/subscriber_statuses/${userUuid}`;
  const response = await fetch(uri, config);

  const { ok } = response;

  if (!ok) {
    return {
      ok,
      errorMessage: await parseErrorMessage(response),
    } as TypeResponseError;
  }

  return {
    ok,
    data: await getJSONData(response),
  } as TypeResponseSuccess<SubscriberStatusesResponse>;
}
